module.exports = __webpack_public_path__ + "static/media/cloud-rain.def0441e.svg";